export enum InsightCategory {
	PolicyIssue = 138,
	EssentialGuide = 139,
	Faq = 130,
	Glossary = 137,
	BizDevelopment = 135,
	Finance = 132,
	PowerplantAsset = 133,
	ParcelsInvestment = 134,
	ForeignMarketReport = 140,
	HouseholdSolarFarm = 131,
	NewsEvent = 136,
}

export const insightCategoryList: { label: string; value: InsightCategory; category: string }[] = [
	{
		label: '정책·이슈',
		value: InsightCategory.PolicyIssue,
		category: 'policy-issue',
	},
	{
		label: '필수 가이드',
		value: InsightCategory.EssentialGuide,
		category: 'essential-guide',
	},
	{
		label: 'FAQ',
		value: InsightCategory.Faq,
		category: 'faq',
	},
	{
		label: '용어사전',
		value: InsightCategory.Glossary,
		category: 'glossary',
	},
	{
		label: '사업개발',
		value: InsightCategory.BizDevelopment,
		category: 'biz-development',
	},
	{
		label: '금융',
		value: InsightCategory.Finance,
		category: 'finance',
	},
	{
		label: '자산관리',
		value: InsightCategory.PowerplantAsset,
		category: 'powerplant-asset',
	},
	{
		label: '분양·투자',
		value: InsightCategory.ParcelsInvestment,
		category: 'parcels-investment',
	},
	{
		label: '해외시장리포트',
		value: InsightCategory.ForeignMarketReport,
		category: 'foreign-market-report',
	},
	{
		label: '가정용 태양광',
		value: InsightCategory.HouseholdSolarFarm,
		category: 'household-solar-farm',
	},
	{
		label: '소식·이벤트',
		value: InsightCategory.NewsEvent,
		category: 'news-event',
	},
];
